import React from "react";
import { formatDateTime, summarizeValidation } from "./patientFormRules";

const CARDS = [
    {
        kind: "billing",
        title: "Validation Facturation",
        tone: "billing",
        accentColor: "#17b978",
    },
    {
        kind: "planification",
        title: "Validation Planification",
        tone: "planification",
        accentColor: "#c8a44d",
    },
];

// Même tampon compact que dans les tableaux Robot et Étiquetage, placé à côté de la case.
function ValidationDetail({ refHour, refUser, tone }) {
    return (
        <span className={`commande-editor-validation-stamp commande-editor-validation-stamp--${tone}`}>
            {refHour && <strong>{formatDateTime(refHour)}</strong>}
            {refUser && <small title={refUser}>{refUser}</small>}
        </span>
    );
}

function ValidationCard({ card, produits, validationOverrides, onToggle }) {
    const { allValidated, refHour, refUser } = summarizeValidation(produits, validationOverrides, card.kind);
    return (
        <div className={`commande-editor-validation-card commande-editor-validation-card--${card.tone}`}>
            <label className="commande-editor-validation-toggle">
                <input
                    type="checkbox"
                    checked={allValidated}
                    onChange={e => onToggle(card.kind, produits, e.target.checked)}
                    style={{ accentColor: card.accentColor }}
                />
                <span className="commande-editor-validation-title">{card.title}</span>
                <span className={`commande-editor-validation-state${allValidated ? " is-validated" : ""}`}>
                    {allValidated ? "Validé" : "Non validé"}
                </span>
            </label>
            {allValidated && (refHour || refUser) && (
                <ValidationDetail refHour={refHour} refUser={refUser} tone={card.tone} />
            )}
        </div>
    );
}

export default function ValidationCards({ produits, validationOverrides, onToggle }) {
    if (produits.length === 0) return null;
    return (
        <div className="commande-editor-validations">
            {CARDS.map(card => (
                <ValidationCard
                    key={card.kind}
                    card={card}
                    produits={produits}
                    validationOverrides={validationOverrides}
                    onToggle={onToggle}
                />
            ))}
        </div>
    );
}
